// import axios from "axios";
import axios from "axios"
import { toggle_popup, toggle_toast } from "./modal"

export const toggle_loader = (data) => ({
  type: "TOGGLE_LOADER",
  data: data,
})

export const put_data = (key, data) => ({
  type: "PUT_DATA",
  key,
  data,
})

export const select_tab = (data) => ({
  type: "SELECT_TAB",
  data,
})

export const set_info = (data) => ({
  type: "SET_INFO",
  data,
})

export const translate = (key) => {
  return (_, getState) => {
    const { transify } = getState().main
    if (transify && transify[key]) {
      return transify[key]
    }
    return key
  }
}

export const get_info = () => {
  return (dispatch, getState) => {
    dispatch(toggle_loader(true))
    const { param } = getState().auth
    axios
      .get(`api/info?access_token=${param.access_token}&lang=${param.lang}`)
      .then((resp) => {
        if (resp.data.status === "error") throw new Error(resp.data.msg)
        const {lang} = resp.data.data?.common_config || 'en';
        document.body.setAttribute('data-lang', lang);
        dispatch(set_info(resp.data.data))
        dispatch(get_winner())
      })
      .catch((err) => {
        dispatch(catch_error(err.message))
      })
      .then(() => {
        dispatch(toggle_loader(false))
      })
  }
}

export const get_winner = () => {
  return (dispatch) => {
    dispatch(toggle_loader(true))
    axios
      .get("api/winner")
      .then((resp) => {
        if (resp.data.status === "error") throw new Error(resp.data.msg)
        dispatch(put_data("winners", resp.data.data?.winner))
      })
      .catch((err) => {
        dispatch(catch_error(err.message))
      })
      .then(() => {
        dispatch(toggle_loader(false))
      })
  }
}

export const post_claim_mission = (mission_id, mission_type) => {
  return (dispatch) => {
    dispatch(toggle_loader(true))
    axios
      .post("api/claim_mission", { mission_id, mission_type })
      .then((resp) => {
        if (resp.data.status === "error") throw new Error(resp.data.msg)
        dispatch(get_info())
        dispatch(toggle_toast(true, "FFIP_SUCCESS"))
      })
      .catch((err) => {
        dispatch(catch_error(err.message))
      })
      .then(() => {
        dispatch(toggle_loader(false))
      })
  }
}

export const post_redeem_code = (code) => {
  return (dispatch) => {
    dispatch(toggle_loader(true))
    axios
      .post(`api/redeem_code`, { code })
      .then((resp) => {
        if (resp.data.status === "error") throw new Error(resp.data.msg)
        dispatch(get_info())
        dispatch(toggle_toast(true, "FFIP_SUCCESS"))
      })
      .catch((err) => {
        dispatch(catch_error(err.message))
      })
      .then(() => {
        dispatch(toggle_loader(false))
      })
  }
}

export const post_spin = (wheel) => {
  return (dispatch, getState) => {
    dispatch(put_data("is_spining", true))
    const { prizes } = getState().main

    axios
      .post("api/spin")
      .then((resp) => {
        if (resp.data.status === "error") throw new Error(resp.data.msg)
        const spinPrize = resp.data.data
        const prizePosition = spinPrize?.position ?? 0
        dispatch(put_data("spin_prize", spinPrize))

        // 45 deg for 1st prize, +45 for every next prize (8 segments)
        if (prizePosition > 0 && prizePosition <= prizes.length) {
          wheel.animation.stopAngle = (prizePosition - 1) * 45
          wheel.startAnimation()
          wheel.rotationAngle = 0
          setTimeout(() => {
            dispatch(toggle_popup(true, "congrats"))
            dispatch(put_data("is_spining", false))
          }, 3200)
        } else {
          // just show actual prize popup if prize position not within prize range
          dispatch(toggle_popup(true, "congrats"))
          dispatch(put_data("is_spining", false))
        }
      })
      .catch((err) => {
        dispatch(put_data("is_spining", false))
        dispatch(catch_error(err.message))
      })
  }
}

export const get_history = () => {
  return (dispatch) => {
    dispatch(toggle_loader(true))
    axios
      .get(`api/history?type=spin`)
      .then((resp) => {
        if (resp.data.status === "error") throw new Error(resp.data.msg)
        dispatch(put_data("history", resp.data.data?.history))
      })
      .catch((err) => {
        dispatch(catch_error(err.message))
      })
      .then(() => {
        dispatch(toggle_loader(false))
      })
  }
}

export const catch_error = (err_msg) => {
  return (dispatch) => {
    dispatch(toggle_toast(true, err_msg || "Unkown error occurred"))
    dispatch(toggle_loader(false))
  }
}
